import React from 'react';

import * as st from './Contact.module.scss';
import FormContact from 'components/Forms/Contact';
import Address from './components/Address';
import ImageSrc from 'images/contacts/bg-left.png';

const Contact = ({ contacts, ...props }) => {
  return (
    <div className={st.wrap}>
      <div className={st.top}>
        <div className={st.left}>
          <h1 className="cr-h1">Contact Us</h1>
          <p className="cr-lead">
            CiRRUS is right choice for your new POS system. Wherever your
            business takes you, we've got you covered.
          </p>
          <FormContact />
        </div>
        <div className={st.right}>
          <div className={st.right_image}>
            <img src={ImageSrc} alt="Need help?" />
          </div>
          <div className={st.texts}>
            <p className="cr-lead cr-txt-medium">Need help?</p>
            <p className="cr-lead cr-text-2">
              Our support team is here to help
            </p>
          </div>
          <div className={st.right_contacts}>
            <a
              href={`mailto:${contacts.email}`}
              className="cr-h2"
              target="_blank"
              rel="noreferrer"
            >
              {contacts.email}
            </a>
            <p className="cr-h2">{contacts.phone}</p>
          </div>
          <a href={`tel:${contacts.phone}`} className={st.right_mobile_link}>
            <span>{contacts.phone}</span>
          </a>
        </div>
      </div>
      <div className={st.bottom}>
        {contacts.addresses.map((address, index) => (
          <Address key={index} data={address} />
        ))}
      </div>
    </div>
  );
};

export default Contact;
